import { colors } from '@10d/tend-ui-tokens/samolet';

import { IColor } from 'types';

export const PLACEMENTS_STATUS_COLORS: IColor = {
  CALL: {
    color: colors.gray0,
    bgcColor: colors.blue600,
    name: 'На проверке',
  },
  IN_PROGRESS: {
    color: colors.gray0,
    bgcColor: colors.blue600,
    name: 'На проверке',
  },
  ACCEPTED: {
    color: colors.gray0,
    bgcColor: colors.green600,
    name: 'Принято',
  },
  NOT_ACCEPTED: {
    color: colors.gray0,
    bgcColor: colors.red600,
    name: 'Не принято',
  },
  NOT_READY: {
    color: colors.gray0,
    bgcColor: colors.gray400,
    name: 'Не готово к вызову',
  },
  NULL: {
    color: '#000000',
    bgcColor: colors.gray0,
    name: '',
  },
};
